module.exports = __webpack_public_path__ + "static/media/phone_status.475c83e0.svg";